<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานอัตราค่าบริการต่าง ๆ ของบริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> รายงานอัตราค่าบริการต่าง ๆ ของบริการโทรศัพท์เคลื่อนที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <el-option label="รายเดือน" value="month"></el-option>
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="กรุณาเลือกประเภทรายงาน" v-if="form.type_report === ''" >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'month' ?  '': 'not_display']" required>
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              :default-value="defaultDate"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']" required>
                            <el-date-picker
                              ref="monthfrom"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthfrom"
                              @change="pickdate('monthfrom')"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthto"
                              @change="pickdate('monthto')"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'year' ?  '': 'not_display']" required>
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              :default-value="defaultDate"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']" required>
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                              @change="pickdate('yearfrom')"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                              @change="pickdate('yearto')"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']" required>
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                              filterable
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              :default-value="defaultDate"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลา" v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required >
                            <el-select
                              filterable
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                              @change="pickquarter('quarterfrom','quarterto')"
                            >
                              <el-option v-for="q in this.q_options.start" :key="q.value" :value="q.value" :disabled="q.disabled" :label="q.label"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              :default-value="defaultDate"
                              @change="pickdate('quarter_year_from')"
                              ref="quarter_year_from"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;&nbsp;
                            <el-select
                              filterable
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                              @change="pickquarter('quarterto','quarterfrom')"
                            >
                              <el-option v-for="q in this.q_options.end" :key="q.value" :value="q.value" :disabled="q.disabled" :label="q.label"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              :default-value="defaultDate"
                              @change="pickdate('quarter_year')"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทชนิดบริการ">
                            <el-select v-model="form.typeService" @change="pick_service">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="เสียง" value="Voice"></el-option>
                              <el-option label="SMS" value="SMS"></el-option>
                              <el-option label="MMS" value="MMS"></el-option>
                              <el-option label="Internet" value="Internet"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ย่านความถี่">
                            <el-checkbox-group v-model="form.frequency">
                              <el-checkbox :label="900">900 MHz</el-checkbox>
                              <el-checkbox :label="1800">1800 MHz</el-checkbox>
                              <el-checkbox :label="2100">2.1 GHz</el-checkbox>
                              <el-checkbox :label="'other'">อื่น ๆ</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="ประเภทผู้ให้บริการ">
                              <el-radio-group v-model="form.compare_type" @change="compareType">
                                <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                                <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item label="กลุ่มผู้ให้บริการ" required>
                              <el-checkbox-group v-model="form.provider_group" :disabled="!cType">
                                <el-checkbox 
                                  ref="provider_group"
                                  v-for="group in this.store_groups" 
                                  :key="group.id" 
                                  :label="group.id">
                                  {{group.group_name_th}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="รายชื่อผู้ให้บริการ" required>
                              <el-checkbox-group v-model="form.provider_list" :disabled="cType">
                                <el-checkbox 
                                ref="provider_list"
                                  v-for="provider in this.store_providers" 
                                  :key="provider.id" 
                                  :label="provider.id">
                                  {{provider.brand_name}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="การจำแนกข้อมูล">
                            <el-radio-group v-model="form.distinguish" @change="classify">
                              <el-radio :label="1">จำแนกข้อมูลตามรายชื่อผู้ให้บริการ</el-radio>
                              <el-radio :label="0">ไม่จำแนกผู้ให้บริการ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="แสดงกราฟแท่งอัตราค่าบริการเฉลี่ย">
                            <el-radio-group v-model="form.barAvg" :disabled="!form.distinguish">
                              <el-radio :label="1" >แสดงค่าเฉลี่ย</el-radio>
                              <el-radio :label="0" >ไม่แสดงค่าเฉลี่ย</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item>
                            <label>ประเภทการถ่วงน้ำหนัก
                              <el-tooltip v-if="!form.barAvg" class="item" effect="dark" content="กรุณาเลือกแสดงกราฟแท่งอัตราค่าบริการเฉลี่ย" placement="top-start">
                                <a class="el-icon-warning-outline" style="padding-left: 10px"></a>
                              </el-tooltip>
                            </label>
                            <br/>
                            <el-radio-group v-model="form.weighting" :disabled="!form.barAvg">
                              <el-radio :label="1">ถ่วงน้ำหนักจำนวนรายการส่งเสริมการขาย</el-radio>
                              <el-radio :label="0">ค่าเฉลี่ยรวมของผู้ให้บริการ (ไม่ถ่วง)</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item>
                            <label>แสดงเส้นกราฟอัตราที่กำกับดูแล
                              <el-tooltip v-if="!form.typeService" class="item" effect="dark" content="กรุณาเลือกประเภทชนิดบริการ" placement="top-start">
                                <a class="el-icon-warning-outline" style="padding-left: 10px"></a>
                              </el-tooltip>
                            </label>
                            <br/>
                            <el-radio-group v-model="form.graphLine" :disabled="!form.typeService">
                              <el-radio v-for="item in regulator" :key="item.id" :label="item.id">{{item.service_name}}</el-radio>
                              <el-radio :label="null">ไม่แสดง</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <div class="col-sm-6">
                            <el-form-item label="แสดงแนวโน้มอัตราค่าบริการในอนาคต">
                              <el-radio-group v-model="form.forcast" >
                                <el-radio :label="1">แสดง</el-radio>
                                <el-radio :label="0">ไม่แสดง</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="แสดงตารางอัตราค่าบริการเฉลี่ย">
                              <el-radio-group v-model="form.avgTable" >
                                <el-radio :label="1">แสดงตารางอัตราค่าบริการเฉลี่ย</el-radio>
                                <el-radio :label="0">ไม่แสดงตารางอัตราค่าบริการเฉลี่ย</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                                <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div v-if="chartResult">
                    <div class="col-sm-12" style="text-align:right;">
                      <el-dropdown v-loading="exporting" @command="exportFile">
                        <span class="btn btn-primary" >
                          Export<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="padding-right:2%">
                          <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                          <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                 </div>
                  <div class="box-body" style="min-height: 500px;" v-if="chartResult">
                    <div class="col-sm-12" ref="chart_item" style="padding-top: 50px;" v-for="(chart,c_index) in this.store_charts" :key="c_index">
                      <charts class="chart" :options="chart" style="max-height: 400px;"></charts><br><br>
                      <template v-if="showDataTable">
                        <div class="data-table" v-for="index in Math.ceil(chart.xAxis.categories.length/12)" :key="index">
                          <table>
                            <tr style="border-color: white;">
                              <th style="width: 150px !important;">ช่วงเวลา</th>
                                <template v-for="item in 12">
                                  <template v-if="(!showRegulate || item > 1) && ((index-1)*12)+(item-1) < chart.xAxis.categories.length-(showRegulate ? 1 : 0)">
                                    <th :key="item" style="width: 80px !important;" v-if="((index-1)*12)+(item-1) < chart.xAxis.categories.length">{{ chart.xAxis.categories[((index-1)*12)+(item-1)] }}</th>
                                    <th :key="item" v-else style="width: 80px !important; border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th>
                                  </template>
                                </template>
                            </tr>
                            <tr v-for="provider in chart.series" :key="provider.id" style="border-color: white;">
                              <th>{{ provider.name }}</th>
                                <template v-for="data in 12" >
                                  <template v-if="(!showRegulate || data > 1) && ((index-1)*12)+(data-1) < chart.xAxis.categories.length-(showRegulate ? 1 : 0)">
                                    <th :key="data" style="width: 80px !important;" v-if="((index-1)*12)+(data-1) < chart.xAxis.categories.length">{{ provider.data[((index-1)*12)+(data-1)] > 0 ? parseFloat(provider.data[((index-1)*12)+(data-1)]).toFixed(2) : '' }}</th>
                                    <th :key="data" v-else style="width: 80px !important; border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th>
                                  </template>
                                </template>
                            </tr>
                          </table>
                          <br/> 
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style scoped>
  .highcharts-data-table {
    overflow-x: scroll;
  }
  .highcharts-data-table th,
  .highcharts-data-table td {
    border: 1px solid silver;
    min-width: 15px !important;
  }
  .custom td,
  .custom th {
    padding: 1px;
    border: 2px solid #ddd;
    border-top: 2px solid #ddd;
  }
  .table.high {
      border-collapse: collapse;
      border-spacing: 0;
      background: rgb(255, 255, 255);
      min-width: 100%;
      margin-top: 10px;
      font-family: sans-serif;
      font-size: 0.9em;
  }
  table.custom tr:nth-child(even), .thead tr {
      background: #f8f8f8;
  }
  table.custom tr:hover {
      background: #eff;
  }

  .data-table tr,
  .data-table th,
  .data-table td {
    border: 1px solid silver;
    height: 20px!important;
    min-width: 80px!important;
    /* max-width: 100px !important; */
  }
  .data-table table{
    width: auto;
    margin-left: auto;
    margin-right: auto;
    padding-left: inherit;
    padding-right: inherit;
  }
  .el-form-item--mini.el-form-item {
    min-height: 62px;
  }
</style>
<script>
import moment from "moment";
import Chart from "chart.js";
import { mapState, mapActions } from "vuex";
import utility from "../../lib/utility.js";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom, Table, TableCell, TableRow, RelativeHorizontalPosition, WidthType, VerticalAlign, TextRun, BorderStyle } from "docx";
import { saveAs } from "file-saver";
let pickdate = Date.now()
export default {
  data() {
    return {
      startOptions : {
        disabledDate(time){
          return time.getTime() >= pickdate
        }
      },
      endOptions : {
        disabledDate(time){
          return time.getTime() <= pickdate
        }
      },
      pickerOptions : {
        disabledDate(time){
          return time.getTime() >= Date.now()
        }
      },
      q_options : {
        start : [
            { value : 1 , label : 1 , disabled : false},
            { value : 2 , label : 2 , disabled : false},
            { value : 3 , label : 3 , disabled : false},
            { value : 4 , label : 4 , disabled : false},
        ],
        end : [
            { value : 1 , label : 1 , disabled : false},
            { value : 2 , label : 2 , disabled : false},
            { value : 3 , label : 3 , disabled : false},
            { value : 4 , label : 4 , disabled : false},
        ]
      },
      show: false,
      displayChart: false,
      textShow: "",
      defaultDate: "",
      dynamicDiv: [],
      mixedChart: [],
      label_position: "top",
      cType : false,
      form: {
        frequency: [900,1800,2100],
        avgTable: 0,
        barAvg: 0,
        type_data: {
          quarterfrom: "",
          quarterto: "",
          yearfrom: "",
          yearto: "",
          monthto: "",
          monthfrom: "",
          month: "",
          year: "",
          quarter: "",
          quarter_year_from: "",
          quarter_year: ""
        },
        provider_group: [],
        provider_list: [],
        graphLine: null,
        distinguish: 1,
        weighting: 0,
        typeService: null,
        type_report: "",
        compare_type: "provider",
        forcast: 0,
        service_status : ['S','U','CS','CU']
      },
      exporting : false
    };
  },
  beforeCreate(){
    this.$store.dispatch('Report_G2/getGroupCompany','mobile')
    this.$store.dispatch('Report_G2/getProviderByType','mobile')
    this.$store.dispatch('Report_G2/getRegulateRate')
  },
  computed: {
    ...mapState({
      store_groups : store => store.Report_G2.provider_group,
      store_providers : store => store.Report_G2.provider_list,
      store_charts : store => store.Report_G2.displayCharts,
      chartResult : store => store.Report_G2.chartResult,
      dataTable : store => store.Report_G2.dataTable,
      showDataNotFound: store => store.Report_G2.showDataNotFound,
      showDataTable: store => store.Report_G2.showDataTable,
      loading: store => store.Report_G2.loading,
      regulator: store => store.Report_G2.regulator,
      showRegulate: store => store.Report_G2.showRegulate
    })
  },
  methods: {
    ...mapActions({
      reportBetweenMonth : "Report_G2/reportBetweenMonth",
      reportMonth : "Report_G2/reportMonth",
      reportYear : "Report_G2/reportYear",
      reportBetweenYear : "Report_G2/reportBetweenYear",
      reportQuarter : "Report_G2/reportQuarter",
      reportBetweenQuarter : "Report_G2/reportBetweenQuarter",
    }),
    clear_data() {
      this.form.type_data = {
        quarterfrom: "",
        quarterto: "",
        yearfrom: "",
        yearto: "",
        monthto: "",
        monthfrom: "",
        month: "",
        year: "",
        quarter: "",
        quarter_year_from: "",
        quarter_year: ""
      };
    },
    find_chart() {
      if (!this.form.type_report) {
        this.MessageBox("แจ้งเตือน", "กรุณาเลือกประเภทรายงาน", "warning",false);
      } else if (this.form.type_report === "month" && !this.form.type_data.month) {
        this.MessageBox("แจ้งเตือน", "กรุณาเลือกเดือน", "warning",false);
      } else if (this.form.type_report == "between_month" && (!this.form.type_data.monthto || !this.form.type_data.monthfrom)) {
        this.MessageBox("แจ้งเตือน","กรุณาเลือกเดือนเริ่มต้น และ เดือนสิ้นสุด","warning",false);
      } else if (this.form.type_report == "between_month" && this.form.type_data.monthfrom > this.form.type_data.monthto) {
        this.MessageBox("แจ้งเตือน","เดือนเริ่มต้น ห้ามมากกว่า เดือนสิ้นสุด","warning",false);
      } else if (this.form.type_report == "year" && !this.form.type_data.year) {
        this.MessageBox("แจ้งเตือน", "กรุณาเลือกปี", "warning");
      } else if (this.form.type_report == "between_year" &&(!this.form.type_data.yearfrom || !this.form.type_data.yearto)) {
        this.MessageBox("แจ้งเตือน","กรุณาเลือกปีเริ่มต้น และ ปีสิ้นสุด","warning",false);
      } else if (this.form.type_report == "between_year" && this.form.type_data.yearfrom > this.form.type_data.yearto) {
        this.MessageBox("แจ้งเตือน","ปีเริ่มต้น ห้ามมากกว่า ปีสิ้นสุด","warning",false);
      } else if (this.form.type_report == "quarter" &&(!this.form.type_data.quarter || !this.form.type_data.quarter_year)) {
        this.MessageBox("แจ้งเตือน", "กรุณาเลือกไตรมาส และ ปี", "warning"),false;
      } else if (this.form.type_report == "between_quarter" &&(!this.form.type_data.quarterfrom ||!this.form.type_data.quarter_year_from ||!this.form.type_data.quarterto ||!this.form.type_data.quarter_year)) {
        this.MessageBox("แจ้งเตือน","กรุณาเลือกช่วงไตรมาส และ ปี ของช่วงไตรมาส","warning",false);
      } else if (this.form.provider_list.length == 0 && this.form.provider_group.length == 0) {
        if(this.form.compare_type == 'group'){
          this.MessageBox("แจ้งเตือน","กรุณาเลือกกลุ่มผู้ให้บริการ","warning",false);
        }else{
          this.MessageBox("แจ้งเตือน","กรุณาเลือกรายชื่อผู้ให้บริการ","warning",false);
        }
      } else {
        let formdata = this.form
            formdata.list = this.form.compare_type == "group" 
            ? this.store_groups.filter(item => this.form.provider_group.includes(item.id)) 
            : this.store_providers.filter(item => this.form.provider_list.includes(item.id))
        this.$store.commit('Report_G2/CLEAR_CHARTS')
        this.$store.commit('Report_G2/DATA_NOT_FOUND',false)
        switch(this.form.type_report){
          case 'month' :
          case 'between_month' :
            this.reportMonth(formdata)
            break
          case 'quarter' :
          case 'between_quarter' :
            this.reportQuarter(formdata)
            break
          case 'year' :
          case 'between_year' :
            this.reportYear(formdata)
            break
        }
      }
    },
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.provider_list = []
      }else{
        this.form.provider_group = []
      }
    },
    pickdate(picked){
      pickdate = this.form.type_data[picked] || Date.now()
      
    },
    pickquarter(picked,compare){
      this.form.type_data[picked]
    },
    pick_service(){
      if(!this.form.typeService){
        this.form.graphLine = null
      }
    },
    classify(){
      if(!this.form.distinguish){
        this.form.barAvg = 0
      }
    },
    pickRegulate(){
      if(!this.form.typeService){
        this.form.graphLine = 0
        this.MessageBox("แจ้งเตือน","ต้องเลือกประเภทชนิดบริการอย่างใดอย่างหนึ่ง","warning",false)
      }
    },
    async exportFile(com){
      if(com=="pdf"){
        this.exporting = true
        let doc = new jsPDF("landscape");
        doc.internal.scaleFactor = 10;
        for(let i = 0, l = this.$refs.chart_item.length; i < l ; i++){
          await this.$html2canvas(this.$refs.chart_item[i], { canvas: null})
          .then(function(canvas){ 
            console.log(canvas) 
          })
          await this.$html2canvas(this.$refs.chart_item[i], { canvas: null})
          .then(function(canvas){
            var ratio = canvas.width > canvas.height ? 300/canvas.width : 210/canvas.height
            var width = canvas.width*ratio
            var height = canvas.height*ratio
            var margin_left = (300-width)/2
            var margin_top = (210-height)/2
            doc.addImage(canvas.toDataURL("image/png", 1.0), "JPEG", margin_left, margin_top, width, height)
            if(i<l-1) doc.addPage()
          })
        }
        doc.save("Report_service_rate.pdf")
        this.exporting = false
      }else if(com=="doc"){
        this.exporting = true
        let img_list = []
        let img_prop = []
        let chart_list = document.querySelectorAll('.chart');
        for(let i = 0; i < chart_list.length; i++) {
          await this.$html2canvas(chart_list[i], { canvas: null})
          .then(function(canvas){ 
            console.log(canvas) 
          })
          await this.$html2canvas(chart_list[i], { canvas: null }).then(function(canvas) {
            const img = canvas.toDataURL("image/png", 1.0);
            img_list.push(img)
            img_prop.push(canvas.width/canvas.height)
          });
        }
        const doc = new Document();
        for (let index in this.store_charts) {
          let chart_data = [].concat(this.store_charts[index].xAxis.categories)
          if(this.showRegulate){
            chart_data.shift()
            chart_data.pop()
          }
          let rows = []
          let size = this.showDataTable ? 560 : 920;
          const image = Media.addImage(doc, img_list[index], size, size/img_prop[index],{});
          let table = [new Paragraph({children: [image], alignment: AlignmentType.CENTER})]
          if (this.showDataTable) {
            for(let table_count = 0; table_count < Math.ceil(chart_data.length/12); table_count++) {
              let temp_cell = []
              temp_cell.push(
                new TableCell({
                  width: {size: 100/(13), type: WidthType.PERCENTAGE},
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: 'ช่วงเวลา',
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
              )
              let max_cell = ((table_count+1)*12) > chart_data.length ? chart_data.length - ((table_count)*12) : 12
              for(let cell_count = 0; cell_count < 12; cell_count++) {
                if(cell_count < max_cell) {
                  temp_cell.push(
                    new TableCell({
                      width: {size: 100/(13), type: WidthType.PERCENTAGE},
                      verticalAlign: VerticalAlign.CENTER,
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: chart_data[(table_count*12)+cell_count],
                              size: 14
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ] 
                    })
                  )
                } else if(chart_data.length > 12){
                  temp_cell.push(
                    new TableCell({
                      width: {size: 100/(13), type: WidthType.PERCENTAGE},
                      verticalAlign: VerticalAlign.CENTER,
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: chart_data[(table_count*12)+cell_count],
                              size: 14
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: {
                          style: BorderStyle.NONE,
                          size: 3
                        },
                        bottom: {
                          style: BorderStyle.NONE,
                          size: 3
                        },
                        right: {
                          style: BorderStyle.NONE,
                          size: 3
                        },
                        left: {
                          style: BorderStyle.NONE,
                          size: 3
                        }
                      }
                    })
                  )
                }
              }
              let temp_row = [new TableRow({
                children: temp_cell
              })]
              for(let provider of this.store_charts[index].series) {
                let provider_data = [].concat(provider.data)
                if(this.showRegulate){
                  provider_data.pop()
                  provider_data.shift()
                }
                temp_cell = []
                temp_cell.push(
                  new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: provider.name,
                            size: 14
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      })
                    ] 
                  })
                )
                for(let cell_count = 0; cell_count < 12; cell_count++) {
                  if(cell_count < max_cell) {
                    temp_cell.push(
                      new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: provider_data[(table_count*12)+cell_count] > 0 ? parseFloat(provider_data[(table_count*12)+cell_count]).toFixed(2) : '',
                                size: 14
                              })
                            ],
                            alignment: AlignmentType.CENTER
                          })
                        ] 
                      })
                    )
                  } else if(chart_data.length > 12){
                    temp_cell.push(
                      new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: provider_data[(table_count*12)+cell_count] > 0 ? parseFloat(provider_data[(table_count*12)+cell_count]).toFixed(2) : '',
                                size: 14
                              })
                            ],
                            alignment: AlignmentType.CENTER
                          })
                        ],
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 3
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 3
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 3
                          },
                          left: {
                            style: BorderStyle.NONE,
                            size: 3
                          }
                        }
                      })
                    )
                  }
                }
                temp_row.push(
                  new TableRow({
                    children: temp_cell
                  })
                )
              }
              table.push(new Table({rows: temp_row}))
              table.push(new Paragraph(''))
            }
          }
          doc.addSection({
            size: {
              orientation: this.showDataTable ? PageOrientation.PORTRAIT : PageOrientation.LANDSCAPE,
            },
            children: table
          });
        }
        Packer.toBlob(doc).then(blob => {
          saveAs(blob, "Report_m2.docx");
          this.exporting =false
        });
      }
    }
  }
};
</script>
